/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Ripia API
 * 美容サロン・リラクゼーション業界向け統合管理SaaSシステムAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTreatmentRecordDto,
  TreatmentRecordListResponseDto,
  TreatmentRecordResponseDto,
  TreatmentRecordsControllerFindAllParams,
  TreatmentRecordsControllerFindByDateRangeParams,
  TreatmentRecordsControllerGetStaffStatisticsParams,
  UpdateTreatmentRecordDto
} from '../../schemas';

import { customInstance } from '../../../lib/custom-instance';




/**
 * @summary 施術記録一覧取得（フィルタ・ページネーション対応）
 */
export const treatmentRecordsControllerFindAll = (
    params?: TreatmentRecordsControllerFindAllParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TreatmentRecordListResponseDto>(
      {url: `/treatment-records`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getTreatmentRecordsControllerFindAllQueryKey = (params?: TreatmentRecordsControllerFindAllParams,) => {
    return [
    `/treatment-records`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTreatmentRecordsControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError = unknown>(params?: TreatmentRecordsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTreatmentRecordsControllerFindAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>> = ({ signal }) => treatmentRecordsControllerFindAll(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TreatmentRecordsControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>>
export type TreatmentRecordsControllerFindAllQueryError = unknown


export function useTreatmentRecordsControllerFindAll<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError = unknown>(
 params: undefined |  TreatmentRecordsControllerFindAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindAll<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError = unknown>(
 params?: TreatmentRecordsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindAll<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError = unknown>(
 params?: TreatmentRecordsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 施術記録一覧取得（フィルタ・ページネーション対応）
 */

export function useTreatmentRecordsControllerFindAll<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError = unknown>(
 params?: TreatmentRecordsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTreatmentRecordsControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 新規施術記録作成
 */
export const treatmentRecordsControllerCreate = (
    createTreatmentRecordDto: CreateTreatmentRecordDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TreatmentRecordResponseDto>(
      {url: `/treatment-records`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTreatmentRecordDto, signal
    },
      );
    }
  


export const getTreatmentRecordsControllerCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof treatmentRecordsControllerCreate>>, TError,{data: CreateTreatmentRecordDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof treatmentRecordsControllerCreate>>, TError,{data: CreateTreatmentRecordDto}, TContext> => {

const mutationKey = ['treatmentRecordsControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof treatmentRecordsControllerCreate>>, {data: CreateTreatmentRecordDto}> = (props) => {
          const {data} = props ?? {};

          return  treatmentRecordsControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TreatmentRecordsControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof treatmentRecordsControllerCreate>>>
    export type TreatmentRecordsControllerCreateMutationBody = CreateTreatmentRecordDto
    export type TreatmentRecordsControllerCreateMutationError = void

    /**
 * @summary 新規施術記録作成
 */
export const useTreatmentRecordsControllerCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof treatmentRecordsControllerCreate>>, TError,{data: CreateTreatmentRecordDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof treatmentRecordsControllerCreate>>,
        TError,
        {data: CreateTreatmentRecordDto},
        TContext
      > => {

      const mutationOptions = getTreatmentRecordsControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 施術記録詳細取得
 */
export const treatmentRecordsControllerFindOne = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TreatmentRecordResponseDto>(
      {url: `/treatment-records/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getTreatmentRecordsControllerFindOneQueryKey = (id?: string,) => {
    return [
    `/treatment-records/${id}`
    ] as const;
    }

    
export const getTreatmentRecordsControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTreatmentRecordsControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>> = ({ signal }) => treatmentRecordsControllerFindOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TreatmentRecordsControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>>
export type TreatmentRecordsControllerFindOneQueryError = void


export function useTreatmentRecordsControllerFindOne<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindOne<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindOne<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 施術記録詳細取得
 */

export function useTreatmentRecordsControllerFindOne<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTreatmentRecordsControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 施術記録更新
 */
export const treatmentRecordsControllerUpdate = (
    id: string,
    updateTreatmentRecordDto: UpdateTreatmentRecordDto,
 ) => {
      
      
      return customInstance<TreatmentRecordResponseDto>(
      {url: `/treatment-records/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTreatmentRecordDto
    },
      );
    }
  


export const getTreatmentRecordsControllerUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof treatmentRecordsControllerUpdate>>, TError,{id: string;data: UpdateTreatmentRecordDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof treatmentRecordsControllerUpdate>>, TError,{id: string;data: UpdateTreatmentRecordDto}, TContext> => {

const mutationKey = ['treatmentRecordsControllerUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof treatmentRecordsControllerUpdate>>, {id: string;data: UpdateTreatmentRecordDto}> = (props) => {
          const {id,data} = props ?? {};

          return  treatmentRecordsControllerUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TreatmentRecordsControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof treatmentRecordsControllerUpdate>>>
    export type TreatmentRecordsControllerUpdateMutationBody = UpdateTreatmentRecordDto
    export type TreatmentRecordsControllerUpdateMutationError = void

    /**
 * @summary 施術記録更新
 */
export const useTreatmentRecordsControllerUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof treatmentRecordsControllerUpdate>>, TError,{id: string;data: UpdateTreatmentRecordDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof treatmentRecordsControllerUpdate>>,
        TError,
        {id: string;data: UpdateTreatmentRecordDto},
        TContext
      > => {

      const mutationOptions = getTreatmentRecordsControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 施術記録削除（キャンセル）
 */
export const treatmentRecordsControllerRemove = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/treatment-records/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getTreatmentRecordsControllerRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof treatmentRecordsControllerRemove>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof treatmentRecordsControllerRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['treatmentRecordsControllerRemove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof treatmentRecordsControllerRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  treatmentRecordsControllerRemove(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TreatmentRecordsControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof treatmentRecordsControllerRemove>>>
    
    export type TreatmentRecordsControllerRemoveMutationError = void

    /**
 * @summary 施術記録削除（キャンセル）
 */
export const useTreatmentRecordsControllerRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof treatmentRecordsControllerRemove>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof treatmentRecordsControllerRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTreatmentRecordsControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 顧客の施術記録一覧取得
 */
export const treatmentRecordsControllerFindByCustomer = (
    customerId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TreatmentRecordResponseDto[]>(
      {url: `/treatment-records/customer/${customerId}`, method: 'GET', signal
    },
      );
    }
  



export const getTreatmentRecordsControllerFindByCustomerQueryKey = (customerId?: string,) => {
    return [
    `/treatment-records/customer/${customerId}`
    ] as const;
    }

    
export const getTreatmentRecordsControllerFindByCustomerQueryOptions = <TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError = unknown>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTreatmentRecordsControllerFindByCustomerQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>> = ({ signal }) => treatmentRecordsControllerFindByCustomer(customerId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TreatmentRecordsControllerFindByCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>>
export type TreatmentRecordsControllerFindByCustomerQueryError = unknown


export function useTreatmentRecordsControllerFindByCustomer<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError = unknown>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindByCustomer<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindByCustomer<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 顧客の施術記録一覧取得
 */

export function useTreatmentRecordsControllerFindByCustomer<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTreatmentRecordsControllerFindByCustomerQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 顧客の最新施術記録取得
 */
export const treatmentRecordsControllerFindLatestByCustomer = (
    customerId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TreatmentRecordResponseDto>(
      {url: `/treatment-records/customer/${customerId}/latest`, method: 'GET', signal
    },
      );
    }
  



export const getTreatmentRecordsControllerFindLatestByCustomerQueryKey = (customerId?: string,) => {
    return [
    `/treatment-records/customer/${customerId}/latest`
    ] as const;
    }

    
export const getTreatmentRecordsControllerFindLatestByCustomerQueryOptions = <TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError = unknown>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTreatmentRecordsControllerFindLatestByCustomerQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>> = ({ signal }) => treatmentRecordsControllerFindLatestByCustomer(customerId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TreatmentRecordsControllerFindLatestByCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>>
export type TreatmentRecordsControllerFindLatestByCustomerQueryError = unknown


export function useTreatmentRecordsControllerFindLatestByCustomer<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError = unknown>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindLatestByCustomer<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindLatestByCustomer<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 顧客の最新施術記録取得
 */

export function useTreatmentRecordsControllerFindLatestByCustomer<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindLatestByCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTreatmentRecordsControllerFindLatestByCustomerQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 予約に紐づく施術記録取得
 */
export const treatmentRecordsControllerFindByReservation = (
    reservationId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TreatmentRecordResponseDto>(
      {url: `/treatment-records/reservation/${reservationId}`, method: 'GET', signal
    },
      );
    }
  



export const getTreatmentRecordsControllerFindByReservationQueryKey = (reservationId?: string,) => {
    return [
    `/treatment-records/reservation/${reservationId}`
    ] as const;
    }

    
export const getTreatmentRecordsControllerFindByReservationQueryOptions = <TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError = unknown>(reservationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTreatmentRecordsControllerFindByReservationQueryKey(reservationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>> = ({ signal }) => treatmentRecordsControllerFindByReservation(reservationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reservationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TreatmentRecordsControllerFindByReservationQueryResult = NonNullable<Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>>
export type TreatmentRecordsControllerFindByReservationQueryError = unknown


export function useTreatmentRecordsControllerFindByReservation<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError = unknown>(
 reservationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindByReservation<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError = unknown>(
 reservationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindByReservation<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError = unknown>(
 reservationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 予約に紐づく施術記録取得
 */

export function useTreatmentRecordsControllerFindByReservation<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError = unknown>(
 reservationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByReservation>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTreatmentRecordsControllerFindByReservationQueryOptions(reservationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 顧客の期間別施術記録取得
 */
export const treatmentRecordsControllerFindByDateRange = (
    customerId: string,
    params: TreatmentRecordsControllerFindByDateRangeParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/treatment-records/customer/${customerId}/range`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getTreatmentRecordsControllerFindByDateRangeQueryKey = (customerId?: string,
    params?: TreatmentRecordsControllerFindByDateRangeParams,) => {
    return [
    `/treatment-records/customer/${customerId}/range`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTreatmentRecordsControllerFindByDateRangeQueryOptions = <TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError = unknown>(customerId: string,
    params: TreatmentRecordsControllerFindByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTreatmentRecordsControllerFindByDateRangeQueryKey(customerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>> = ({ signal }) => treatmentRecordsControllerFindByDateRange(customerId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TreatmentRecordsControllerFindByDateRangeQueryResult = NonNullable<Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>>
export type TreatmentRecordsControllerFindByDateRangeQueryError = unknown


export function useTreatmentRecordsControllerFindByDateRange<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError = unknown>(
 customerId: string,
    params: TreatmentRecordsControllerFindByDateRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindByDateRange<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError = unknown>(
 customerId: string,
    params: TreatmentRecordsControllerFindByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerFindByDateRange<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError = unknown>(
 customerId: string,
    params: TreatmentRecordsControllerFindByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 顧客の期間別施術記録取得
 */

export function useTreatmentRecordsControllerFindByDateRange<TData = Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError = unknown>(
 customerId: string,
    params: TreatmentRecordsControllerFindByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerFindByDateRange>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTreatmentRecordsControllerFindByDateRangeQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary スタッフ別施術統計取得
 */
export const treatmentRecordsControllerGetStaffStatistics = (
    staffId: string,
    params?: TreatmentRecordsControllerGetStaffStatisticsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/treatment-records/staff/${staffId}/statistics`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getTreatmentRecordsControllerGetStaffStatisticsQueryKey = (staffId?: string,
    params?: TreatmentRecordsControllerGetStaffStatisticsParams,) => {
    return [
    `/treatment-records/staff/${staffId}/statistics`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTreatmentRecordsControllerGetStaffStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError = unknown>(staffId: string,
    params?: TreatmentRecordsControllerGetStaffStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTreatmentRecordsControllerGetStaffStatisticsQueryKey(staffId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>> = ({ signal }) => treatmentRecordsControllerGetStaffStatistics(staffId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(staffId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TreatmentRecordsControllerGetStaffStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>>
export type TreatmentRecordsControllerGetStaffStatisticsQueryError = unknown


export function useTreatmentRecordsControllerGetStaffStatistics<TData = Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError = unknown>(
 staffId: string,
    params: undefined |  TreatmentRecordsControllerGetStaffStatisticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerGetStaffStatistics<TData = Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError = unknown>(
 staffId: string,
    params?: TreatmentRecordsControllerGetStaffStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>,
          TError,
          Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTreatmentRecordsControllerGetStaffStatistics<TData = Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError = unknown>(
 staffId: string,
    params?: TreatmentRecordsControllerGetStaffStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary スタッフ別施術統計取得
 */

export function useTreatmentRecordsControllerGetStaffStatistics<TData = Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError = unknown>(
 staffId: string,
    params?: TreatmentRecordsControllerGetStaffStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof treatmentRecordsControllerGetStaffStatistics>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTreatmentRecordsControllerGetStaffStatisticsQueryOptions(staffId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




